import { PlayerOrNone } from '../../jscaip/Player';
export class TaflPawn {
    owner;
    king;
    static UNOCCUPIED = new TaflPawn(PlayerOrNone.NONE, false);
    static PLAYER_ONE_KING = new TaflPawn(PlayerOrNone.ONE, true);
    static PLAYER_ONE_PAWN = new TaflPawn(PlayerOrNone.ONE, false);
    static PLAYER_ZERO_KING = new TaflPawn(PlayerOrNone.ZERO, true);
    static PLAYER_ZERO_PAWN = new TaflPawn(PlayerOrNone.ZERO, false);
    constructor(owner, king) {
        this.owner = owner;
        this.king = king;
    }
    isKing() {
        return this.king;
    }
    getOwner() {
        return this.owner;
    }
    equals(other) {
        return this === other;
    }
}
